import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-12 mr-auto ml-auto" }
const _hoisted_2 = { class: "wizard-container" }
const _hoisted_3 = {
  class: "card card-wizard active",
  "data-color": "primary"
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "col-3 mb-3" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "col-3 mb-3" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "col-10 mb-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "col-10 mb-3" }
const _hoisted_14 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarraBotoes = _resolveComponent("BarraBotoes")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_component_BarraBotoes, {
                  loadingSave: _ctx.loadingSave,
                  idRegistroCarregado: _ctx.$route.params.id,
                  key: _ctx.keyRV,
                  gridViewLink: '/patrimonio/pattipobem/'+_ctx.$route.params.patGrupoId,
                  onLimpar: _ctx.limparFormulario,
                  onExcluir: _ctx.excluir
                }, null, 8, ["loadingSave", "idRegistroCarregado", "gridViewLink", "onLimpar", "onExcluir"])),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", null, "Ordem", -1)),
                      _createVNode(_component_Field, {
                        name: "ordem",
                        class: "form-control",
                        type: "text",
                        modelValue: _ctx.model.ordem,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.ordem) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "ordem" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", null, "Codigo", -1)),
                      _createVNode(_component_Field, {
                        name: "codigo",
                        class: "form-control",
                        type: "text",
                        modelValue: _ctx.model.codigo,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.codigo) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "codigo" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", null, "Descrição", -1)),
                      _createVNode(_component_Field, {
                        name: "descricao",
                        class: "form-control",
                        type: "text",
                        modelValue: _ctx.model.descricao,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.descricao) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "descricao" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", null, "Observação", -1)),
                      _createVNode(_component_Field, {
                        name: "observacao",
                        as: "textarea",
                        class: "form-control",
                        modelValue: _ctx.model.observacao,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.observacao) = $event)),
                        rows: "4"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, { name: "observacao" })
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}